<template>
  <component
    :is="tag"
    :to="to"
    :href="href"
    :class="['cta-btn', size, { block: block }]"
  >
    <span class="cta-btn__label">
      <slot>Termin jetzt sichern</slot>
    </span>
    <span class="cta-btn__arrow" aria-hidden="true">→</span>
  </component>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  to: { type: [String, Object], default: null },
  href: { type: String, default: null },
  size: {
    type: String,
    default: "lg",
    validator: (v) => ["sm", "md", "lg", "xl"].includes(v),
  },
  block: { type: Boolean, default: false },
});

const tag = computed(() => {
  if (props.to) return "router-link";
  if (props.href) return "a";
  return "button";
});
</script>

<style scoped>
.cta-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-family: "Lato", sans-serif;
  font-weight: 900;
  color: #fff;
  background: #f59e0b;
  border: none;
  cursor: pointer;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-radius: 999px;
  transition: all 0.25s ease;
  box-shadow: 0 8px 24px rgba(245, 158, 11, 0.35);
}

.cta-btn:hover {
  background: #d97706;
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(245, 158, 11, 0.45);
}

.cta-btn.block {
  width: 100%;
}

.cta-btn.sm {
  padding: 12px 22px;
  font-size: 13px;
}

.cta-btn.md {
  padding: 14px 28px;
  font-size: 14px;
}

.cta-btn.lg {
  padding: 18px 36px;
  font-size: 16px;
}

.cta-btn.xl {
  padding: 24px 48px;
  font-size: 18px;
}

.cta-btn__arrow {
  font-size: 1.2em;
  transition: transform 0.25s ease;
}

.cta-btn:hover .cta-btn__arrow {
  transform: translateX(4px);
}

@media (max-width: 600px) {
  .cta-btn.xl {
    padding: 20px 32px;
    font-size: 16px;
  }
}
</style>
